module.exports = __webpack_public_path__ + "img/filter.efdea42d.svg";